// import { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// export const useUnsavedChangesWarning = (isDirty) => {
//   const location = useLocation();

//   useEffect(() => {
//     if (!isDirty) return;

//     const handleBeforeUnload = (event) => {
//       event.preventDefault();
//       event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
//       return event.returnValue;
//     };

//     const handlePopState = (event) => {
//       const proceed = window.confirm(
//         "You have unsaved changes. Do you really want to leave this page?"
//       );
//       if (!proceed) {
//         window.history.pushState(null, '', location.pathname);
//       }
//     };

//     // Block programmatic navigation
//     const originalPushState = window.history.pushState;
//     const originalReplaceState = window.history.replaceState;

//     window.history.pushState = function(...args) {
//       const proceed = window.confirm(
//         "You have unsaved changes. Do you really want to leave this page?"
//       );
//       if (proceed) {
//         originalPushState.apply(window.history, args);
//       }
//     };

//     window.history.replaceState = function(...args) {
//       const proceed = window.confirm(
//         "You have unsaved changes. Do you really want to leave this page?"
//       );
//       if (proceed) {
//         originalReplaceState.apply(window.history, args);
//       }
//     };

//     window.addEventListener('beforeunload', handleBeforeUnload);
//     window.addEventListener('popstate', handlePopState);

//     return () => {
//       window.history.pushState = originalPushState;
//       window.history.replaceState = originalReplaceState;
//       window.removeEventListener('beforeunload', handleBeforeUnload);
//       window.removeEventListener('popstate', handlePopState);
//     };
//   }, [isDirty, location.pathname]);
// };


import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const useUnsavedChangesWarning = (isDirty) => {
  const location = useLocation();
  const hasSetupBackBlock = useRef(false);

  useEffect(() => {
    if (!isDirty) return;

    // Setup back button blocking
    if (!hasSetupBackBlock.current) {
      window.history.pushState(null, '', window.location.href);
      hasSetupBackBlock.current = true;
    }

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
      return event.returnValue;
    };

    const handlePopState = (event) => {
      const proceed = window.confirm(
        "You have unsaved changes. Do you really want to leave this page?"
      );
      if (!proceed) {
        window.history.pushState(null, '', window.location.href);
      } else {
        hasSetupBackBlock.current = false;
      }
    };

    // Block programmatic navigation
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function(...args) {
      const proceed = window.confirm(
        "You have unsaved changes. Do you really want to leave this page?"
      );
      if (proceed) {
        hasSetupBackBlock.current = false;
        originalPushState.apply(window.history, args);
      }
    };

    window.history.replaceState = function(...args) {
      const proceed = window.confirm(
        "You have unsaved changes. Do you really want to leave this page?"
      );
      if (proceed) {
        originalReplaceState.apply(window.history, args);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
      if (hasSetupBackBlock.current) {
        hasSetupBackBlock.current = false;
      }
    };
  }, [isDirty]);
};
